import React, { useState, useEffect } from 'react';
import { Button } from 'rsuite';
import { FaExclamationCircle } from 'react-icons/fa';
import { useWarnings } from '../../hooks/useWarnings';
import * as S from './styles';
import RModal from '../Rsuite/Modal';

const GlobalWarningModal = () => {
  const { warnings, updateWarning } = useWarnings();

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedAviso, setSelectedAviso] = useState(null);

  useEffect(() => {
    const importanteNaoLido = warnings.find(w => +w.Important === 1 && +w.Lido === 0);

    if (importanteNaoLido) {
      setSelectedAviso(importanteNaoLido);
      setModalOpen(true);
    } else {
      setModalOpen(false);
      setSelectedAviso(null);
    }
  }, [warnings]);

  const handleClose = async () => {
    if (!selectedAviso) return;

    try {
      await updateWarning(selectedAviso);
      setModalOpen(false);
    } catch (error) {
      console.error("Erro ao marcar aviso importante como lido", error);
      setModalOpen(false);
    }
  };

  const formatData = (dataString) => {
    if (!dataString) return '';
    return new Date(dataString).toLocaleDateString('pt-BR', {
        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  };

  return (
    <>
      {modalOpen && (
        <RModal
          open={modalOpen}
          onClose={handleClose}
          bodyStyle={{ width: '100%', maxWidth: '650px' }}
          title={
            <>
              <FaExclamationCircle color="#ef4444" style={{ marginRight: 10 }} />
              {selectedAviso?.Titulo}
            </>
          }
          footer={
            <S.FooterModal>
              <S.Span>Recebido em {formatData(selectedAviso?.CreatedAt)}</S.Span>
              <Button onClick={handleClose} appearance="primary" color="red">
                Entendi
              </Button>
            </S.FooterModal>
          }
        >
          <S.ContainerModal>
            {selectedAviso?.Descricao}
          </S.ContainerModal>
        </RModal>
      )}
    </>
  );
};

export default GlobalWarningModal;
